// MSE bracket structure - APA Modified Single Elimination format
// This format gives losers a second chance by "flipping" them into a separate bracket path
// Winners advance RIGHT, Losers drop to flip matches on the LEFT side
//
// The MSE format is template-based for each player count since the structure is specific

// Build complete MSE bracket template for 8 players based on APA diagram (Example #1)
// APA "Bracketology 101" - Modified Single Elimination for 8 players
// Total matches: 13 (8 players, each can lose once in main + flip path)
function buildMSE8PlayerTemplate() {
    return [
        // === WINNERS SIDE (advancing RIGHT) ===
        // Column 1 - Initial matches (4 matches for 8 players)
        { matchNum: 1, col: 1, row: 0, p1Source: "seed1", p2Source: "seed8" },
        { matchNum: 2, col: 1, row: 1, p1Source: "seed4", p2Source: "seed5" },
        { matchNum: 3, col: 1, row: 2, p1Source: "seed2", p2Source: "seed7" },
        { matchNum: 4, col: 1, row: 3, p1Source: "seed3", p2Source: "seed6" },

        // Column 2 - Winners bracket round 2 (2 matches)
        // Winners of M1 & M2 play, Winners of M3 & M4 play
        { matchNum: 5, col: 2, row: 0, p1Source: "Winner of M1", p2Source: "Winner of M2" },
        { matchNum: 6, col: 2, row: 1, p1Source: "Winner of M3", p2Source: "Winner of M4" },

        // Column 3 - Winners bracket semi-final (1 match)
        { matchNum: 7, col: 3, row: 0, p1Source: "Winner of M5", p2Source: "Winner of M6" },

        // === FLIP SIDE (losers drop LEFT into flip matches) ===
        // Column 4 - First flip round: Losers from Column 1 pair up
        { matchNum: 8, col: 4, row: 0, p1Source: "Loser of M1", p2Source: "Loser of M2", isFlipMatch: true },
        { matchNum: 9, col: 4, row: 1, p1Source: "Loser of M3", p2Source: "Loser of M4", isFlipMatch: true },

        // Column 5 - Flip round 2: Losers from Col 2 play flip winners
        { matchNum: 10, col: 5, row: 0, p1Source: "Loser of M5", p2Source: "Winner of M8", isFlipMatch: true },
        { matchNum: 11, col: 5, row: 1, p1Source: "Loser of M6", p2Source: "Winner of M9", isFlipMatch: true },

        // Column 6 - Flip semi-final
        { matchNum: 12, col: 6, row: 0, p1Source: "Winner of M10", p2Source: "Winner of M11", isFlipMatch: true },

        // === CONVERGENCE ===
        // Column 7 - Loser of winners semi plays flip bracket winner
        { matchNum: 13, col: 7, row: 0, p1Source: "Loser of M7", p2Source: "Winner of M12", isFlipMatch: true },

        // Column 8 - Final: Winners bracket champ vs flip bracket survivor
        { matchNum: 14, col: 8, row: 0, p1Source: "Winner of M7", p2Source: "Winner of M13" },
    ];
}

// Build complete MSE bracket template for 16 players based on APA diagram (Example #2)
// APA "Bracketology 101" - Modified Single Elimination for 16 players
// Total matches: 29 (M13/M14 winners don't play each other - they wait for convergence)
function buildMSE16PlayerTemplate() {
    return [
        // === WINNERS SIDE (advancing RIGHT) ===
        // Column 1 - Initial matches (8 matches for 16 players)
        { matchNum: 1, col: 1, row: 0, p1Source: "seed1", p2Source: "seed16" },
        { matchNum: 2, col: 1, row: 1, p1Source: "seed8", p2Source: "seed9" },
        { matchNum: 3, col: 1, row: 2, p1Source: "seed4", p2Source: "seed13" },
        { matchNum: 4, col: 1, row: 3, p1Source: "seed5", p2Source: "seed12" },
        { matchNum: 5, col: 1, row: 4, p1Source: "seed2", p2Source: "seed15" },
        { matchNum: 6, col: 1, row: 5, p1Source: "seed7", p2Source: "seed10" },
        { matchNum: 7, col: 1, row: 6, p1Source: "seed3", p2Source: "seed14" },
        { matchNum: 8, col: 1, row: 7, p1Source: "seed6", p2Source: "seed11" },

        // Column 2 - Winners bracket round 2 (4 matches)
        { matchNum: 9, col: 2, row: 0, p1Source: "Winner of M1", p2Source: "Winner of M2" },
        { matchNum: 10, col: 2, row: 1, p1Source: "Winner of M3", p2Source: "Winner of M4" },
        { matchNum: 11, col: 2, row: 2, p1Source: "Winner of M5", p2Source: "Winner of M6" },
        { matchNum: 12, col: 2, row: 3, p1Source: "Winner of M7", p2Source: "Winner of M8" },

        // Column 3 - Winners bracket round 3 (2 matches)
        // Winners of M13/M14 wait for convergence - they do NOT play each other
        { matchNum: 13, col: 3, row: 0, p1Source: "Winner of M9", p2Source: "Winner of M10" },
        { matchNum: 14, col: 3, row: 1, p1Source: "Winner of M11", p2Source: "Winner of M12" },

        // === FLIP SIDE (losers drop LEFT into flip matches) ===
        // Column 4 - First flip round: Losers from Column 1 pair up (4 flip matches)
        { matchNum: 15, col: 4, row: 0, p1Source: "Loser of M1", p2Source: "Loser of M2", isFlipMatch: true },
        { matchNum: 16, col: 4, row: 1, p1Source: "Loser of M3", p2Source: "Loser of M4", isFlipMatch: true },
        { matchNum: 17, col: 4, row: 2, p1Source: "Loser of M5", p2Source: "Loser of M6", isFlipMatch: true },
        { matchNum: 18, col: 4, row: 3, p1Source: "Loser of M7", p2Source: "Loser of M8", isFlipMatch: true },

        // Column 5 - Flip round 2: Losers from Col 2 play flip winners
        { matchNum: 19, col: 5, row: 0, p1Source: "Loser of M9", p2Source: "Winner of M15", isFlipMatch: true },
        { matchNum: 20, col: 5, row: 1, p1Source: "Loser of M10", p2Source: "Winner of M16", isFlipMatch: true },
        { matchNum: 21, col: 5, row: 2, p1Source: "Loser of M11", p2Source: "Winner of M17", isFlipMatch: true },
        { matchNum: 22, col: 5, row: 3, p1Source: "Loser of M12", p2Source: "Winner of M18", isFlipMatch: true },

        // Column 6 - Flip round 3
        { matchNum: 23, col: 6, row: 0, p1Source: "Winner of M19", p2Source: "Winner of M20", isFlipMatch: true },
        { matchNum: 24, col: 6, row: 1, p1Source: "Winner of M21", p2Source: "Winner of M22", isFlipMatch: true },

        // Column 7 - Flip round 4: Losers from Col 3 play flip winners
        { matchNum: 25, col: 7, row: 0, p1Source: "Loser of M13", p2Source: "Winner of M23", isFlipMatch: true },
        { matchNum: 26, col: 7, row: 1, p1Source: "Loser of M14", p2Source: "Winner of M24", isFlipMatch: true },

        // === CONVERGENCE - Flip winners return to play Winners bracket ===
        // Column 8 - Convergence matches: Flip winners play Winners bracket winners
        // Winner of M25 plays Winner of M13, Winner of M26 plays Winner of M14
        { matchNum: 27, col: 8, row: 0, p1Source: "Winner of M13", p2Source: "Winner of M25" },
        { matchNum: 28, col: 8, row: 1, p1Source: "Winner of M14", p2Source: "Winner of M26" },

        // Column 9 - Championship Final
        { matchNum: 29, col: 9, row: 0, p1Source: "Winner of M27", p2Source: "Winner of M28" },
    ];
}

// Build complete MSE bracket template for 32 players
// APA "Bracketology 101" - Modified Single Elimination for 32 players
// Total matches: 61
// Seeding follows standard tournament bracket order to distribute BYEs evenly
function buildMSE32PlayerTemplate() {
    return [
        // === WINNERS SIDE (advancing RIGHT) ===
        // Column 1 - Initial matches (16 matches for 32 players)
        // Seeding pattern ensures BYEs (high seeds) are spread throughout the bracket
        // Top half of bracket (rows 0-7)
        { matchNum: 1, col: 1, row: 0, p1Source: "seed1", p2Source: "seed32" },
        { matchNum: 2, col: 1, row: 1, p1Source: "seed16", p2Source: "seed17" },
        { matchNum: 3, col: 1, row: 2, p1Source: "seed9", p2Source: "seed24" },
        { matchNum: 4, col: 1, row: 3, p1Source: "seed8", p2Source: "seed25" },
        { matchNum: 5, col: 1, row: 4, p1Source: "seed5", p2Source: "seed28" },
        { matchNum: 6, col: 1, row: 5, p1Source: "seed12", p2Source: "seed21" },
        { matchNum: 7, col: 1, row: 6, p1Source: "seed13", p2Source: "seed20" },
        { matchNum: 8, col: 1, row: 7, p1Source: "seed4", p2Source: "seed29" },
        // Bottom half of bracket (rows 8-15)
        { matchNum: 9, col: 1, row: 8, p1Source: "seed3", p2Source: "seed30" },
        { matchNum: 10, col: 1, row: 9, p1Source: "seed14", p2Source: "seed19" },
        { matchNum: 11, col: 1, row: 10, p1Source: "seed11", p2Source: "seed22" },
        { matchNum: 12, col: 1, row: 11, p1Source: "seed6", p2Source: "seed27" },
        { matchNum: 13, col: 1, row: 12, p1Source: "seed7", p2Source: "seed26" },
        { matchNum: 14, col: 1, row: 13, p1Source: "seed10", p2Source: "seed23" },
        { matchNum: 15, col: 1, row: 14, p1Source: "seed15", p2Source: "seed18" },
        { matchNum: 16, col: 1, row: 15, p1Source: "seed2", p2Source: "seed31" },

        // Column 2 - Winners bracket round 2 (8 matches)
        { matchNum: 17, col: 2, row: 0, p1Source: "Winner of M1", p2Source: "Winner of M2" },
        { matchNum: 18, col: 2, row: 1, p1Source: "Winner of M3", p2Source: "Winner of M4" },
        { matchNum: 19, col: 2, row: 2, p1Source: "Winner of M5", p2Source: "Winner of M6" },
        { matchNum: 20, col: 2, row: 3, p1Source: "Winner of M7", p2Source: "Winner of M8" },
        { matchNum: 21, col: 2, row: 4, p1Source: "Winner of M9", p2Source: "Winner of M10" },
        { matchNum: 22, col: 2, row: 5, p1Source: "Winner of M11", p2Source: "Winner of M12" },
        { matchNum: 23, col: 2, row: 6, p1Source: "Winner of M13", p2Source: "Winner of M14" },
        { matchNum: 24, col: 2, row: 7, p1Source: "Winner of M15", p2Source: "Winner of M16" },

        // Column 3 - Winners bracket round 3 (4 matches)
        { matchNum: 25, col: 3, row: 0, p1Source: "Winner of M17", p2Source: "Winner of M18" },
        { matchNum: 26, col: 3, row: 1, p1Source: "Winner of M19", p2Source: "Winner of M20" },
        { matchNum: 27, col: 3, row: 2, p1Source: "Winner of M21", p2Source: "Winner of M22" },
        { matchNum: 28, col: 3, row: 3, p1Source: "Winner of M23", p2Source: "Winner of M24" },

        // Column 4 - Winners bracket round 4 (2 matches)
        // Winners of M29/M30 wait for convergence - they do NOT play each other
        { matchNum: 29, col: 4, row: 0, p1Source: "Winner of M25", p2Source: "Winner of M26" },
        { matchNum: 30, col: 4, row: 1, p1Source: "Winner of M27", p2Source: "Winner of M28" },

        // === FLIP SIDE (losers drop LEFT into flip matches) ===
        // Column 5 - First flip round: Losers from Column 1 pair up (8 flip matches)
        { matchNum: 31, col: 5, row: 0, p1Source: "Loser of M1", p2Source: "Loser of M2", isFlipMatch: true },
        { matchNum: 32, col: 5, row: 1, p1Source: "Loser of M3", p2Source: "Loser of M4", isFlipMatch: true },
        { matchNum: 33, col: 5, row: 2, p1Source: "Loser of M5", p2Source: "Loser of M6", isFlipMatch: true },
        { matchNum: 34, col: 5, row: 3, p1Source: "Loser of M7", p2Source: "Loser of M8", isFlipMatch: true },
        { matchNum: 35, col: 5, row: 4, p1Source: "Loser of M9", p2Source: "Loser of M10", isFlipMatch: true },
        { matchNum: 36, col: 5, row: 5, p1Source: "Loser of M11", p2Source: "Loser of M12", isFlipMatch: true },
        { matchNum: 37, col: 5, row: 6, p1Source: "Loser of M13", p2Source: "Loser of M14", isFlipMatch: true },
        { matchNum: 38, col: 5, row: 7, p1Source: "Loser of M15", p2Source: "Loser of M16", isFlipMatch: true },

        // Column 6 - Flip round 2: Losers from Col 2 play flip winners (8 matches)
        { matchNum: 39, col: 6, row: 0, p1Source: "Loser of M17", p2Source: "Winner of M31", isFlipMatch: true },
        { matchNum: 40, col: 6, row: 1, p1Source: "Loser of M18", p2Source: "Winner of M32", isFlipMatch: true },
        { matchNum: 41, col: 6, row: 2, p1Source: "Loser of M19", p2Source: "Winner of M33", isFlipMatch: true },
        { matchNum: 42, col: 6, row: 3, p1Source: "Loser of M20", p2Source: "Winner of M34", isFlipMatch: true },
        { matchNum: 43, col: 6, row: 4, p1Source: "Loser of M21", p2Source: "Winner of M35", isFlipMatch: true },
        { matchNum: 44, col: 6, row: 5, p1Source: "Loser of M22", p2Source: "Winner of M36", isFlipMatch: true },
        { matchNum: 45, col: 6, row: 6, p1Source: "Loser of M23", p2Source: "Winner of M37", isFlipMatch: true },
        { matchNum: 46, col: 6, row: 7, p1Source: "Loser of M24", p2Source: "Winner of M38", isFlipMatch: true },

        // Column 7 - Flip round 3: Winners pair up (4 matches)
        { matchNum: 47, col: 7, row: 0, p1Source: "Winner of M39", p2Source: "Winner of M40", isFlipMatch: true },
        { matchNum: 48, col: 7, row: 1, p1Source: "Winner of M41", p2Source: "Winner of M42", isFlipMatch: true },
        { matchNum: 49, col: 7, row: 2, p1Source: "Winner of M43", p2Source: "Winner of M44", isFlipMatch: true },
        { matchNum: 50, col: 7, row: 3, p1Source: "Winner of M45", p2Source: "Winner of M46", isFlipMatch: true },

        // Column 8 - Flip round 4: Losers from Col 3 play flip winners (4 matches)
        { matchNum: 51, col: 8, row: 0, p1Source: "Loser of M25", p2Source: "Winner of M47", isFlipMatch: true },
        { matchNum: 52, col: 8, row: 1, p1Source: "Loser of M26", p2Source: "Winner of M48", isFlipMatch: true },
        { matchNum: 53, col: 8, row: 2, p1Source: "Loser of M27", p2Source: "Winner of M49", isFlipMatch: true },
        { matchNum: 54, col: 8, row: 3, p1Source: "Loser of M28", p2Source: "Winner of M50", isFlipMatch: true },

        // Column 9 - Flip round 5: Winners pair up (2 matches)
        { matchNum: 55, col: 9, row: 0, p1Source: "Winner of M51", p2Source: "Winner of M52", isFlipMatch: true },
        { matchNum: 56, col: 9, row: 1, p1Source: "Winner of M53", p2Source: "Winner of M54", isFlipMatch: true },

        // Column 10 - Flip round 6: Losers from Col 4 play flip winners (2 matches)
        { matchNum: 57, col: 10, row: 0, p1Source: "Loser of M29", p2Source: "Winner of M55", isFlipMatch: true },
        { matchNum: 58, col: 10, row: 1, p1Source: "Loser of M30", p2Source: "Winner of M56", isFlipMatch: true },

        // === CONVERGENCE - Flip winners return to play Winners bracket ===
        // Column 11 - Convergence matches: Flip winners play Winners bracket winners
        { matchNum: 59, col: 11, row: 0, p1Source: "Winner of M29", p2Source: "Winner of M57" },
        { matchNum: 60, col: 11, row: 1, p1Source: "Winner of M30", p2Source: "Winner of M58" },

        // Column 12 - Championship Final
        { matchNum: 61, col: 12, row: 0, p1Source: "Winner of M59", p2Source: "Winner of M60" },
    ];
}

// MSE bracket configuration maps
const MSE_BRACKET_MAPS = {
    8: {
        totalColumns: 8,
        template: buildMSE8PlayerTemplate()
    },
    16: {
        totalColumns: 9,  // 9 columns: cols 1-3 winners, cols 4-7 flip, col 8 convergence, col 9 final
        template: buildMSE16PlayerTemplate()
    },
    32: {
        totalColumns: 12,  // 12 columns: cols 1-4 winners, cols 5-10 flip, col 11 convergence, col 12 final
        template: buildMSE32PlayerTemplate()
    }
};

// BYE row distribution order - evenly spread using tournament bracket pattern
// For 16 first-round matches (rows 0-15): M1, M15, M7, M11, M3, M13, M5, M9, M2, M14, M6, M10, M4, M12, M8, M16
// This spreads BYEs evenly: first at top, then bottom, then middle, etc.
const MSE_32_BYE_ROW_ORDER = [0, 14, 6, 10, 2, 12, 4, 8, 1, 13, 5, 9, 3, 11, 7, 15];

// For 8 first-round matches (rows 0-7): M1, M7, M3, M5, M2, M6, M4, M8
const MSE_16_BYE_ROW_ORDER = [0, 6, 2, 4, 1, 5, 3, 7];

// For 4 first-round matches (rows 0-3): M1, M3, M2, M4
const MSE_8_BYE_ROW_ORDER = [0, 2, 1, 3];

export function buildModifiedSingleEliminationBracket(players) {
    const playerCount = players.length;

    // MSE requires at least 3 players
    if (playerCount < 3) {
        throw new Error(`MSE format requires at least 3 players. You have ${playerCount} player(s).`);
    }

    // Determine which template to use based on player count
    // 3-8 players use the 8-player template with BYEs
    // 9-16 players use the 16-player template with BYEs
    // 17-32 players use the 32-player template with BYEs
    let slots;
    let byeRowOrder;
    if (playerCount <= 8) {
        slots = 8;
        byeRowOrder = MSE_8_BYE_ROW_ORDER;
    } else if (playerCount <= 16) {
        slots = 16;
        byeRowOrder = MSE_16_BYE_ROW_ORDER;
    } else if (playerCount <= 32) {
        slots = 32;
        byeRowOrder = MSE_32_BYE_ROW_ORDER;
    } else {
        throw new Error(`MSE format supports up to 32 players. You have ${playerCount} players.`);
    }

    // Get bracket configuration
    const config = MSE_BRACKET_MAPS[slots];
    if (!config || !config.template) {
        throw new Error(`MSE format not supported for ${playerCount} players. Supported sizes: 3-32 players.`);
    }

    // Calculate number of BYEs needed
    const numByes = slots - playerCount;

    // Get which rows should have BYEs (evenly distributed)
    const byeRows = new Set(byeRowOrder.slice(0, numByes));

    // Create player queue - players will be assigned in order to non-BYE slots
    const playerQueue = [...players];

    const matches = [];

    // Build matches from template
    config.template.forEach(templateMatch => {
        let p1Name, p2Name;
        let p1Ref = null, p2Ref = null;

        // For first round matches (col 1), check if this row should have a BYE
        if (templateMatch.col === 1) {
            const row = templateMatch.row;
            if (byeRows.has(row)) {
                // This row has a BYE - player gets the bye (p1), BYE is opponent (p2)
                p1Name = playerQueue.shift() || "BYE";
                p2Name = "BYE";
            } else {
                // Normal match - both players from queue
                p1Name = playerQueue.shift() || "BYE";
                p2Name = playerQueue.shift() || "BYE";
            }
        } else {
            // Later rounds - use Winner/Loser references
            if (templateMatch.p1Source.startsWith("Winner of") || templateMatch.p1Source.startsWith("Loser of")) {
                p1Name = templateMatch.p1Source;
                p1Ref = templateMatch.p1Source;
            } else {
                p1Name = templateMatch.p1Source;
            }

            if (templateMatch.p2Source.startsWith("Winner of") || templateMatch.p2Source.startsWith("Loser of")) {
                p2Name = templateMatch.p2Source;
                p2Ref = templateMatch.p2Source;
            } else {
                p2Name = templateMatch.p2Source;
            }
        }

        const match = {
            id: `mse-${templateMatch.col}-${templateMatch.row}`,
            matchNum: templateMatch.matchNum,
            p1: { name: p1Name, ref: p1Ref },
            p2: { name: p2Name, ref: p2Ref },
            from: [],
            bracket: "MSE",
            round: templateMatch.col,
            col: templateMatch.col,
            row: templateMatch.row,
            score1: "0",
            score2: "0",
            table: "",
            started: false,
            finished: false,
            status: "Pending",
            winner: "",
            isFlipMatch: templateMatch.isFlipMatch || false,
        };

        matches.push(match);
    });

    // Sort matches by match number for proper display order
    matches.sort((a, b) => a.matchNum - b.matchNum);

    return matches;
}

export function getModifiedSingleEliminationStandings(bracket) {
    const places = [];
    const placed = new Set();

    // Find the final match (highest round/column number)
    const maxCol = Math.max(...bracket.map(m => m.col));
    const finalMatch = bracket.find(m => m.bracket === "MSE" && m.col === maxCol && m.finished);
    
    if (finalMatch && finalMatch.winner) {
        // Champion
        if (!finalMatch.winner.includes("Winner of") && !placed.has(finalMatch.winner)) {
            places.push([finalMatch.winner]);
            placed.add(finalMatch.winner);
        }
        
        // Runner-up
        const runnerUp = finalMatch.p1.name === finalMatch.winner ? finalMatch.p2.name : finalMatch.p1.name;
        if (runnerUp && !runnerUp.includes("Winner of") && !placed.has(runnerUp)) {
            places.push([runnerUp]);
            placed.add(runnerUp);
        }
    }

    // Group eliminated players by column (later columns = better placement)
    const elimByColumn = {};
    bracket.forEach(match => {
        if (match.finished && match.winner) {
            const loser = match.p1.name === match.winner ? match.p2.name : match.p1.name;
            if (loser && !loser.includes("Winner of") && !loser.includes("Loser of") && loser !== "BYE" && !placed.has(loser)) {
                if (!elimByColumn[match.col]) {
                    elimByColumn[match.col] = [];
                }
                elimByColumn[match.col].push(loser);
            }
        }
    });

    // Add eliminated players by column (higher columns first = better placement)
    const elimColumns = Object.keys(elimByColumn).map(Number).sort((a, b) => b - a);
    for (const col of elimColumns) {
        const eliminated = elimByColumn[col].filter(name => !placed.has(name));
        if (eliminated.length > 0) {
            places.push(eliminated);
            eliminated.forEach(name => placed.add(name));
        }
    }

    // Add any remaining unplaced players
    const allPlayers = new Set();
    bracket.forEach(match => {
        [match.p1, match.p2].forEach(player => {
            if (player?.name &&
                player.name !== "BYE" &&
                !player.name.startsWith("Winner of") &&
                !player.name.startsWith("Loser of") &&
                typeof player.name === "string") {
                allPlayers.add(player.name);
            }
        });
    });

    const neverPlaced = Array.from(allPlayers).filter(name => !placed.has(name));
    if (neverPlaced.length > 0) {
        places.push(neverPlaced);
    }

    return places;
}

export function propagateModifiedSingleEliminationWinners(bracket) {
    // Sort matches by match number to ensure proper propagation order
    const sortedMatches = [...bracket].sort((a, b) => (a.matchNum || 0) - (b.matchNum || 0));

    for (const match of sortedMatches) {
        if (match.finished && match.winner) {
            const winner = match.winner;
            const loser = (match.p1.name === winner) ? match.p2.name : match.p1.name;

            // Update all subsequent matches
            for (const m of bracket) {
                if (m.p1?.ref === `Winner of M${match.matchNum}`) {
                    m.p1.name = winner;
                }
                if (m.p2?.ref === `Winner of M${match.matchNum}`) {
                    m.p2.name = winner;
                }
                if (m.p1?.ref === `Loser of M${match.matchNum}`) {
                    m.p1.name = loser;
                }
                if (m.p2?.ref === `Loser of M${match.matchNum}`) {
                    m.p2.name = loser;
                }
            }
        }
    }
}

export function finalizeModifiedSingleEliminationByeMatches(bracket, optionalCallback) {
    // Recursively auto-advance BYE matches until no more can be advanced
    let advancedAny;
    let iterationCount = 0;
    const maxIterations = 20; // Safety limit to prevent infinite loops

    do {
        advancedAny = false;
        iterationCount++;

        // First, propagate any winners from completed matches
        propagateModifiedSingleEliminationWinners(bracket);

        // Check if propagation created new BYE vs BYE scenarios from completed matches
        bracket.forEach(match => {
            if (match.finished && match.status.includes("Auto-advanced") &&
                match.p1.name === "BYE" && match.p2.name === "BYE" &&
                match.winner !== "BYE") {
                // This match was completed as bye_vs_reference but propagation made it BYE vs BYE
                // Reset it to be processed correctly as BYE vs BYE
                match.finished = false;
                match.winner = "";
                match.status = "Pending";
            }
        });

        // Then check for new BYE matches to auto-advance in round order
        const sortedMatches = [...bracket].sort((a, b) => a.round - b.round);

        for (const match of sortedMatches) {
            if (!match.finished) {
                const shouldAdvance = shouldAutoAdvanceBye(match);

                if (shouldAdvance) {
                    advancedAny = true;

                    if (shouldAdvance.type === "bye_vs_bye") {
                        // BYE vs BYE: winner is BYE
                        match.winner = "BYE";
                        match.finished = true;
                        match.status = "Auto-advanced (BYE vs BYE)";
                    } else if (shouldAdvance.type === "player_vs_bye") {
                        // Named player vs BYE: player wins
                        match.winner = shouldAdvance.winner;
                        match.finished = true;
                        match.status = "Auto-advanced (BYE)";
                    } else if (shouldAdvance.type === "bye_vs_reference") {
                        // BYE vs Winner/Loser of MX: Winner/Loser reference wins
                        match.winner = shouldAdvance.winner;
                        match.finished = true;
                        match.status = "Auto-advanced (BYE)";
                    }

                    if (optionalCallback) {
                        optionalCallback(match);
                    }
                }
            }
        }

        // Safety check to prevent infinite loops
        if (iterationCount >= maxIterations) {
            console.warn(`finalizeModifiedSingleEliminationByeMatches: Reached maximum iterations (${maxIterations}), stopping to prevent infinite loop`);
            break;
        }

    } while (advancedAny);

    // Final propagation to ensure all winners are updated
    propagateModifiedSingleEliminationWinners(bracket);
}

// Helper function to determine if a match should auto-advance due to BYE
function shouldAutoAdvanceBye(match) {
    const p1Name = match.p1?.name || "";
    const p2Name = match.p2?.name || "";

    // Case 1: BYE vs BYE - auto-advance with BYE as winner
    if (p1Name === "BYE" && p2Name === "BYE") {
        return { type: "bye_vs_bye" };
    }

    // Case 2: Must have exactly one BYE and one other player
    const hasBye = p1Name === "BYE" || p2Name === "BYE";
    if (!hasBye) return false;

    // Get the non-BYE player name
    const nonByeName = p1Name === "BYE" ? p2Name : p1Name;

    // Case 3: BYE vs Winner/Loser of MX - auto-advance the reference
    if (nonByeName.startsWith("Winner of") || nonByeName.startsWith("Loser of")) {
        return { type: "bye_vs_reference", winner: nonByeName };
    }

    // Don't auto-advance if non-BYE name is empty or just whitespace
    if (!nonByeName || nonByeName.trim() === "") {
        return false;
    }

    // Case 4: Named player vs BYE - auto-advance the named player
    return { type: "player_vs_bye", winner: nonByeName };
}